/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

// The editor creator to use.

// Most plugins have been disabled for current use case
// For all default set of plugins see https://github.com/ckeditor/ckeditor5/blob/master/packages/ckeditor5-build-balloon/src/ckeditor.js

import BalloonEditorBase from '@ckeditor/ckeditor5-editor-balloon/src/ballooneditor';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
import MediaUpload from './ckeditor5-media-upload/media-upload';
import Link from './ckeditor5-link/link';
import Mention from './ckeditor5-mention/src/mention.js';
import { MentionCustomization } from './mention-customization';

export default class CustomBalloonEditor extends BalloonEditorBase {}
// Plugins to include in the build.
CustomBalloonEditor.builtinPlugins = [
  Mention,
  MentionCustomization,
  Autoformat,
  Essentials,
  Link,
  Paragraph,
  TextTransformation,
  MediaUpload,
];

// Editor configuration.
CustomBalloonEditor.defaultConfig = {
  // This value must be kept in sync with the language defined in webpack.config.js.
  language: 'en',
};
